import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import SecuredFileChange from '../../components/SecuredFileChange';
import { endPoints } from '../../Config';
import { handlePostRequest } from '../../service/PostTemplate';
import { handleGetRequest } from '../../service/GetTemplate';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';

const EditTicket = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [ticketStatus, setTicketStatus] = useState([]);
    const [ticketDetails, setTicketDetails] = useState([]);
    const [thread, setThread] = useState([]);

    const ticketImageRef = useRef(null);

    const location = useLocation();
    const { rowData } = location.state || {};

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        Message: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Title must contain only alphanumeric values'),
        Files: Yup.string().required('This field is required'),
        StatusId: Yup.mixed().required('This field is required')
    });

    const formik = useFormik({
        validationSchema,
        initialValues: {
            StatusId: '',
            Message: '',
            TicketId: '',
            CreatedBy: '',
            Files: ''
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('user') || '{}');

            const formData = new FormData();

            setLoadingBtn(true);

            formData.append('Message', data?.Message || '');
            formData.append('StatusId', data?.StatusId || '');
            formData.append('TicketId', rowData.id || '');
            formData.append('CreatedBy', user?.data?.userId || '');

            if (selectedFile) formData.append('Files', selectedFile);

            const response = await dispatch(handlePostRequest(formData, endPoints.createTicketThread, true));
            if (response?.status === 200) {
                formik.resetForm();
                getTicketById();
            }
            setLoadingBtn(false);
        }
    });
    const handleTicketIcon = () => {
        ticketImageRef.current.click();
    };

    function handleTicketImageChange(event) {
        setSelectedFile(null);
        formik.setFieldValue('Files', '');
        const selectedFile = event.target.files[0];
        const fileTypes = ['image'];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
        } else if (newFile) {
            formik.setFieldValue('Files', newFile?.name);
            setSelectedFile(newFile);
        }
    }

    const getTicketStatus = async () => {
        const response = await handleGetRequest(endPoints.getDropdownTicketsStatus, true, false, dispatch);
        if (response) {
            setTicketStatus(response?.data);
        }
    };

    useEffect(() => {
        getTicketStatus();
    }, []);

    const getTicketById = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getTicketById(rowData.id), true);
        if (response) {
            setTicketDetails(response?.data?.ticketDetails);
            setThread(response?.data?.threads);
        }
        setLoadingBtn(false);
    };

    useEffect(() => {
        if (rowData) {
            getTicketById();
        }
    }, [rowData]);

    const orderDateTemplate = (rowData) => {
        const isoDate = rowData?.createdAt;
        const date = new Date(isoDate);

        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();

        const formattedDate = `${dd}/${mm}/${yyyy}`;
        return <p>{formattedDate}</p>;
    };
    return (
        <div className="p-4">
            <div className="card Card__Round">
                <div className="p-fluid p-formgrid grid mb-5">
                    <div className="col-12 md:col-3">
                        <div className="p-field">
                            <label className="text-lg font-semibold" htmlFor="TicketTypeId">
                                Ticket ID
                            </label>
                            <p className="text-sm font-semibold">{ticketDetails?.id}</p>
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="p-field">
                            <label className="text-lg font-semibold" htmlFor="TicketTypeId">
                                Ticket Status
                            </label>
                            <p className="text-sm font-semibold">{ticketDetails?.ticketStatus}</p>
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="p-field">
                            <label className="text-lg font-semibold" htmlFor="TicketTypeId">
                                Ticket Type
                            </label>
                            <p className="text-sm font-semibold">{ticketDetails?.ticketType}</p>
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="p-field">
                            <label className="text-lg font-semibold" htmlFor="TicketTypeId">
                                Ticket Title
                            </label>
                            <p className="text-sm font-semibold">{ticketDetails?.title}</p>
                        </div>
                    </div>
                    <div className="col-12 md:col-12">
                        <div className="p-field">
                            <label className="text-lg font-semibold" htmlFor="TicketTypeId">
                                Message
                            </label>
                            <p className="text-sm font-semibold">{ticketDetails?.message}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card Card__Round">
                <div className="flex justify-content-between align-items-center mb-3">
                    <p className="text-xl font-semibold">Add New Thread</p>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid grid mb-5">
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="StatusId">Status</label>
                                <Dropdown id="StatusId" name="StatusId" value={formik?.values?.StatusId} options={ticketStatus} optionLabel="name" optionValue="id" onChange={formik.handleChange} placeholder="Select Type" className="w-full" />
                                {formik.touched.StatusId && formik.errors.StatusId && <small className="p-error">{formik.errors.StatusId}</small>}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-12">
                            <div className="p-field">
                                <label htmlFor="Message">Update Message </label>
                                <InputTextarea id="Message" name="Message" placeholder="Add Message..." value={formik?.values?.Message} maxLength={200} onChange={formik.handleChange} />
                                {formik.touched.Message && formik.errors.Message && <small className="p-error">{formik.errors.Message}</small>}
                            </div>
                        </div>{' '}
                        <div className="col-12 md:col-6">
                            <div className="mb-3">
                                <div className="field">
                                    <label htmlFor="image">
                                        Upload Image <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <div className="file-input-container file-input-wrapper w-100" onClick={handleTicketIcon}>
                                        <input type="file" accept="image/*" style={{ display: 'none' }} ref={ticketImageRef} onChange={handleTicketImageChange} className="file-input-field" />
                                        <input type="text" placeholder="Choose a file..." value={formik?.values?.Files} readOnly className="file-input-field" />
                                    </div>
                                    {formik.touched.Message && formik.errors.Files ? <small className="p-error">{formik.errors.Files}</small> : ''}
                                </div>
                            </div>
                        </div>
                        <div className="live__SearchBtn p-field col-12 md:col-12 gap-2">
                            <Button label="Update" icon="pi pi-pencil" type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                            <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => navigate('/tickets')} />
                        </div>
                    </div>
                </form>
            </div>
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <DataTable
                            paginator
                            rows={15}
                            rowsPerPageOptions={[5, 10, 20]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                            emptyMessage="No List found."
                            responsiveLayout="scroll"
                            value={thread}
                            className="p-datatable-sm datatable-responsive"
                        >
                            <Column field="threadId" header="ID " />
                            <Column body={orderDateTemplate} header="Created On" />
                            <Column field="createdBy" header="Created By" />
                            <Column field="threadStatus" header="Status" />
                            <Column field="threadMessage" header="Message" />
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditTicket;
